import PropTypes from 'prop-types';
import React from 'react';

const SortPills = function SortPills(props) {
  const {
    options,
    activeOption,
    onChange,
  } = props;
  const sortOptions = options.map((opt) => {
    const optionClasses = [];
    if (activeOption === opt.value) {
      optionClasses.push('uk-active');
    }
    return (
      <li key={`key-${opt.value}`} className={optionClasses.join(' ')}>
        <a href={`#sort-${opt.value}`} onClick={() => onChange(opt.value)}>{opt.label}</a>
      </li>
    );
  });
  return (
    <ul className="uk-subnav uk-subnav-pill">
      {sortOptions}
    </ul>
  );
};

SortPills.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    label: PropTypes.string,
  })),
  activeOption: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func,
};

SortPills.defaultProps = {
  onChange: () => {},
};

export default SortPills;



// WEBPACK FOOTER //
// ./src/components/SortPills.js